import Vue from 'vue';
export default () => {
    const _prop = {
        get: () => {
            return document.title;
        },
        set: (title) => {
            document.title = `${process.env.VUE_APP_TITLE}`;
        },
    };
    Object.defineProperty(Vue, 'pageTitle', _prop);
    Object.defineProperty(Vue.prototype, '$pageTitle', _prop);
};
